import BetModel from "../model/BetModel";
import Layout from "../utils/Layout";
import BaseView from "./BaseView";
import Utils from "../utils/Utils";
import { IObjectConfig } from "../baseConfigs/layoutConfigShema";
import { ITextFieldStyleOptions } from "./components/TextField";
import App from "../App";
import GameEvents from "../const/GameEvents";
import ConsoleUtil from "../utils/ConsoleUtil";

type TextFontSizes = {
    money: number,
    cents: number,
    currency: number
}

export abstract class AbstractMoneyField extends BaseView {

    protected _config: MoneyFieldConfig;

    constructor(config?: MoneyFieldConfig) {
        super();
        if (!config) {
            this._config = new MoneyFieldConfig();
        } else {
            this._config = config;
        }

        App.dispatcher.on(GameEvents.UI_UPDATE, () => { this.createBoundsRect(); }, this);
        // this.createBoundsRect();
        // this.createTextfields();
    }



    abstract get bounds(): { width: number, height: number };
    abstract set bounds(bounds: { width: number, height: number });

    public abstract clone():AbstractMoneyField;
    public abstract createBoundsRect(): void;
    protected abstract positionText();

    public abstract rescale(bounds:IObjectConfig);

    public centerVertical() {
        ConsoleUtil.warn("NO VERICAL CENTERING AVAILABLE");
    }

    abstract set value(value: number);
    abstract get value(): number;

    abstract set style(style: ITextFieldStyleOptions);



}


export class MoneyFieldConfig implements IMoneyFieldConfig {
    currencyRelativeSize: number = 100;
    centsRelativeSize: number = 100;
    coinsRelativeSize: number = 70;
    moneyFontSize: number = 60;
    minFontSize: number = 10;
    fontFamily: string = "Arial";
    bounds: IObjectConfig = {
        width: 400,
        height: 200,
        x: 0,
        y: 0
    };
    align: string = "center";
    shouldFitToBounds: boolean = true;
    alignOnlyMoney: boolean = false;
    keepCurrencySize: boolean = true;
    spaceBetweenThousands: boolean = false;
    symbolBetweenThousands: string = " ";
    decimalSeparatorSymbol: string = ".";
    prependSymbol: boolean = false;
    showIdentifier: boolean = true; // whether to show Currency name
    showSymbol = false; // if set to true currency symbol will be visualized, else ISO will be used
    hideWhenZero: boolean = false;
    centerAlignOnlyMoney: boolean = false; // todo implement !!!
    currency = "USD";
    alternative: boolean = false;

    constructor(vars?: IMoneyFieldConfig) {
        if (vars) {
            Utils.serialize(vars, this);
        }
    }
}

export interface IMoneyFieldConfig {
    currencyFontSize?: number;
    centsFontSize?: number;
    moneyFontSize?: number;
    coinsRelativeSize?: number;
    minFontSize?: number;
    fontFamily?: string;
    bounds?: IObjectConfig;
    align?: string;
    shouldFitToBounds?: boolean;
    alignOnlyMoney?: boolean;
    keepCurrencySize?: boolean;
    spaceBetweenThousands?: boolean;
    symbolBetweenThousands?: string;
    decimalSeparatorSymbol?: string;
    prependSymbol?: boolean;
    showIdentifier?: boolean;
    hideWhenZero?: boolean;
    currency?: string;
    alternative?: boolean;
}


